import * as React from 'react';
import bugsnag from 'bugsnag-js';
import createPlugin from 'bugsnag-react';

export default ({
  apiKey, version, releaseStage, notifyReleaseStage, type, ...props
} = {}) => {
  if (!apiKey && !process.env.BUGSNAG_JS_API_KEY) {
    return props.children;
  }

  const bug = bugsnag({
    apiKey: apiKey || process.env.BUGSNAG_JS_API_KEY,
    appVersion: version || '1.0.0',
    releaseStage: releaseStage || 'production',
    notifyReleaseStage: notifyReleaseStage || ['production'],

  });

  bug.app.type = type || process.env.BUGSNAG_HOSTNAME;

  const ErrorBoundary = bug.use(createPlugin(React));
  return <ErrorBoundary> {props.children} </ErrorBoundary>;
};
